//
// ServerConfig.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./MediaType";
import "./particles/SupportedType";
import "@sas-dvr/ltjs-commons/resources/network/URL";

var ServerConfig = createModule("transport::ServerConfig", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel","transport::MediaType"], EventDispatcher, [
    ,
    {
        joinQueryTimeoutSeconds: 4,
        maxRowsGeoBubble: 4,
        maxRowsTimeSeries: 4,
        maxRowsButtonBar: 4,
        maxRowsGeoContour: 4,
        homePageUrl: 1,
        bannerMessage: 7,
        iframeSandbox: 7,
        reportImagesJobCreationUrl: 7,
        maxRowsGeoLine: 4,
        allowWebContentForMobile: 2,
        maxRowsGeoRegion: 4,
        supportedTypes: [1],
        maxRowsWordCloud: 4,
        exportExcelColumnLimit: 4,
        maxRowsBubble: 4,
        exportExcelRowLimit: 4,
        maxRowsTextInput: 4,
        maxRowsListTable: 4,
        maxRowsKpi: 4,
        maxRowsScatter: 4,
        logoUrl: 7,
        maxRowsHeatbox: 4,
        comparisonEpsilon: 6,
        enableMultiDimensionalSubtotals: 2,
        allowGuest: 2,
        maxRowsGeoPie: 4,
        exportTSVandCSVRowLimit: 4,
        maxRowsKeyValue: 4,
        searchAvailable: 2,
        title: 7,
        enableInteractiveData: 2,
        offlineLimit: 5,
        maxRowsGeoScatter: 4,
        passcodeAttempts: 4,
        reportImagesAvailable: 2,
        maxRowsDualAxisTimeSeries: 4,
        maxRowsGeoHeatmap: 4,
        maxRowsHeatmap: 4,
        maxRowsList: 4,
        printAvailable: 2,
        maxRowsDropdown: 4,
        transportServicesVersion: 7,
        exportTSVandCSVColumnLimit: 4,
        socketTimeoutLiveCancellableMillis: 4,
        maxRowsCrosstab: 4,
        transportServicesPlatform: 7,
        passcodeTimeout: 5,
        maxRowsCustomContent: 4,
        maxRowsGraphDefault: 4,
        catalogSearchAvailable: 2,
        environmentManagerUrl: 1,
        maxRowsTreeMap: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ServerConfig;
